<template>
    <div class="m-news-detail">
       <div @touchstart.stop="listTouchStart" @touchmove.stop="listTouchMove"  @touchend.stop="listTouchUp">
           <p class="title">
               {{refush.title}}
           </p>
           <div class="m-news-content" v-html="report.content"></div>
       </div>
        <p class="link">感谢您的阅读，<a :href="report.origin">点击阅读原文</a></p>
    </div>
</template>

<script>
let FLAG = 140; //左滑动关闭距离

export default {
    name: 'NewsDetail',
    props: ['news', 'prevDetail', 'nextDetail', 'index'],
    data() {
        let report = require(`assets/json/news/${this.news.id}`);
        if (report.default) {
            report = report.default
        }
        return {
            detail: this.news,
            report,
            imgListStartX: 0,
        };
    },
    computed: {
        refush: function() {
            return this.news;
        },
    },
    methods: {
        getDetail() {
            let report = require(`assets/json/news/${this.news.id}`);
            if (report.default) {
                report = report.default
            }
            this.report = report;
        },
        listTouchStart(event) {
            this.imgListStartX = event.changedTouches[0].pageX;
        },
        listTouchMove(event) {
            let num = Math.floor(
                event.changedTouches[0].pageX - this.imgListStartX,
            );
            if (num > FLAG) {
                this.$emit('closedetail');
                return;
            }
        },
        listTouchUp() {
            // if (this.imgListX + this.imgMoveX >= 0) {
            //     this.imgListX = 0;
            //     return;
            // } else if (
            //     this.imgListX + this.imgMoveX <=
            //     document.body.offsetWidth - this.honorWidth
            // ) {
            //     this.imgListX =
            //         this.honorWidth * -1 + document.body.offsetWidth - 30;
            //     return;
            // }
            // this.imgListX = this.imgListX + this.imgMoveX;
        },
    },
    mounted() {
        this.getDetail();
    },
    beforeUpdate: function() {
        this.detail = this.news;
        this.getDetail();
    },
};
</script>

<style lang="less">
.m-news-detail {
    position: relative;
    font-family: PingFangSC-Regular;
    padding: 2.21rem 0.607rem 0;
    .title {
        padding: 0.75rem 0 22px;
    }
}
.m-news-content {
    p {
        font-size: 0.428rem;
        color: #4a4a4a;
        line-height: 0.75rem;
        padding-bottom: 0.5rem;
    }
    img {
        width: 100%;
    }
}
.link {
    font-family: PingFangSC-Regular;
    position: relative;
    z-index: 20;
    font-size: 0.428rem;
    color: #4a4a4a;
    line-height: 0.75rem;
    padding-bottom: 0.6rem;
    a {
        color: #41b466;
    }
}
</style>
